import React from "react"

const Spinner = () => (
  <div className="spinner-border spinner-border-sm" role="status">
    <span className="sr-only">Chargement...</span>
  </div>
)

export default Spinner
